<script setup lang="ts">
import { AppText } from '@shared/ui/typography'
import { WrapperGeneralInfo } from '@shared/ui/wrappers'
import { CardAdmin } from '@shared/ui/cards'
import { BtnPrimary } from '@shared/ui/buttons'

import { useSectionCustomerGeneral } from '../model/section-customer-general.hook'
import CustomerActions from './CustomerActions.vue'
import CustomerLabels from './CustomerLabels.vue'
import CustomerSubscriptionModals from './CustomerSubscriptionModals.vue'
import CustomerGeneralInfo from './CustomerGeneralInfo.vue'
import CustomerIntegrationInfo from './CustomerIntegrationInfo.vue'
import CustomerOtherInfo from './CustomerOtherInfo.vue'
import CustomerBalanceInfo from './CustomerBalanceInfo.vue'
import CustomerPurchaseInfo from './CustomerPurchaseInfo.vue'
import CustomerNotesInfo from './CustomerNotesInfo.vue'

defineOptions({
  name: 'SectionCustomerGeneral',
})

const {
  refTitle,
  hasCustomer,
  hasDetails,
  isProcessing,
  canViewCustomers,
  canManageCustomers,
  refSubscriptions,
  activeSubscriptionModal,
  canManageSubscriptions,
  save,
} = useSectionCustomerGeneral()
</script>

<template>
  <CardAdmin
    flexible
    fullwidth
    class="section-customer-general"
  >
    <template #title>
      <div class="section-customer-general__title">
        <AppText name="h3">
          {{ refTitle }}
        </AppText>
        <CustomerLabels />
      </div>
    </template>
    <template #header>
      <div
        v-if="canViewCustomers"
        class="section-customer-general__controls"
      >
        <CustomerActions />
        <BtnPrimary
          v-if="canManageCustomers && hasDetails"
          text="Save"
          color="emerald"
          :disabled="isProcessing"
          @click="save"
        />
      </div>
    </template>
    <WrapperGeneralInfo v-if="hasCustomer">
      <template #info>
        <CustomerGeneralInfo />
        <template v-if="hasDetails">
          <CustomerIntegrationInfo />
          <CustomerOtherInfo />
        </template>
      </template>
      <template #additional>
        <template v-if="hasDetails">
          <CustomerBalanceInfo />
          <CustomerPurchaseInfo
            :subscriptions="refSubscriptions"
            :can-manage="canManageSubscriptions"
          />
          <CustomerNotesInfo />
        </template>
      </template>
    </WrapperGeneralInfo>
    <CustomerSubscriptionModals :active-modal="activeSubscriptionModal" />
  </CardAdmin>
</template>

<style scoped lang="scss" src="./SectionCustomerGeneral.scss" />
